import React from 'react';
import RowCard from "./RowCard";
import {Form, Label, Row} from "reactstrap";
import InputNumber from "./InputNumber";
import {getZh} from "../../constants/general";

const RenderCol = (props) => {
    const {
        t,
        i18n,
        currency,
        PackagePrices,
        fields,
        activeBetTypeId,
        handleDigitKeyPress,
        onClickBetNumber,
        onClickAmount,
        setFilter,
        onInputChange,
        amountDigitInput,
        firstDigitInput,
        twoDigitInput,
        isMobile
    } = props;

    const isMatrix = activeBetTypeId === "MATRIX";
    const isZh = i18n.language === "zh";

    return (
        <RowCard nonMb bodyClass="p-input-mo w-100">
            <Row className="mr-2 justify-content-end">
                <Form onSubmit={(e) => e.preventDefault()}>
                    <Row className="m-0 align-items-end">
                        <div style={{paddingRight: ".8vw"}} className="col">
                            <div className="align-items-center d-flex ">
                                <div className="pr-0 m-0">
                                    <InputNumber
                                        onKeyDown={handleDigitKeyPress}
                                        onMouseDown={(e) => {
                                            e.stopPropagation();
                                        }}
                                        width="6vw"
                                        readOnly={true}
                                        className="form-control"
                                        maxLength="3"
                                        isMatrix={isMatrix}
                                        name="numberFrom"
                                        t={t}
                                        onFocus={() =>
                                            setFilter({isFocus: true, focusIndex: 0})
                                        }
                                        onSelect={() => setFilter({isSelectFrom: true})}
                                        value={fields.numberFrom ?? ""}
                                        onChange={onInputChange}
                                        myRef={firstDigitInput}
                                    />
                                </div>
                                {activeBetTypeId !== "NORMAL" && (
                                    <div style={{paddingLeft: ".3vw"}} className="pr-0">
                                        <InputNumber
                                            onKeyDown={handleDigitKeyPress}
                                            onMouseDown={(e) => {
                                                e.stopPropagation();
                                            }}
                                            maxLength="3"
                                            width="6vw"
                                            t={t}
                                            isActive={activeBetTypeId !== "NORMAL"}
                                            readOnly={true}
                                            className="form-control"
                                            name="numberTo"
                                            isMatrix={isMatrix}
                                            onFocus={() =>
                                                setFilter({isFocus: true, focusIndex: 1})
                                            }
                                            onSelect={() => setFilter({isSelectTo: true})}
                                            disabled={activeBetTypeId === "NORMAL"}
                                            value={fields.numberTo ?? ""}
                                            onChange={onInputChange}
                                            myRef={twoDigitInput}
                                            id="numberTo"
                                        />
                                    </div>
                                )}

                            </div>
                        </div>
                        <div className="ml-0 mr-0 text-right">
                            <Label className="m-0 pr-2"
                                   onClick={() => {
                                       setFilter(pre => ({
                                           ...pre,
                                           fields: {
                                               ...pre.fields,
                                               betAmount: 0
                                           }
                                       }))
                                   }}>ទឹកប្រាក់
                                <button type="button" className="bg-transparent border-0 mb-0 cursor-pointer">
                                    <i
                                        className="feather icon-refresh-ccw ml-3 f-16 text-warning w-mobile"/>
                                </button>
                            </Label>
                            <InputNumber
                                className="form-control"
                                onKeyDown={handleDigitKeyPress}
                                onMouseDown={(e) => {
                                    e.stopPropagation();
                                }}
                                maxLength="10"
                                width="6.5vw"
                                value={fields.betAmount === 0 ? "" : fields.betAmount}
                                readOnly={true}
                                isKhr={currency === "KHR"}
                                name="betAmount"
                                onFocus={() =>
                                    setFilter({isFocus: true, focusIndex: 4})
                                }
                                onSelect={() => setFilter({isBetAmount: true})}
                                myRef={amountDigitInput}
                                onChange={onInputChange}
                            />
                        </div>
                    </Row>
                </Form>
            </Row>
            <div className={`pt-num-mo ${isMobile ? "d-num w-100" : "d-flex justify-content-end"}`}>
                {Array(10).fill(0).map((e, i) => {
                    return <button onClick={() => onClickBetNumber(i)} key={i} className="number-btn">
                        {i}
                    </button>
                })}
                {isMobile && <button onClick={() => onClickBetNumber("", true)}
                                     className={`number-btn last`}>
                    <i className="feather icon-arrow-left"/>
                </button>}
            </div>
            <div
                className={`mt-3 lo5d-button ${isMobile ? "d-price mr-0" : "d-flex flex-wrap justify-content-end mr-2"}`}>
                {
                    PackagePrices.map((p, i) => {
                        return <button
                            key={i}
                            onClick={() => onClickAmount(p)}
                            className={`mb-1 post price`}>{isZh ? getZh[p.value] : p.label}</button>
                    })
                }
            </div>
        </RowCard>
    );
};

export default RenderCol;